import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';

import BiologistexTheme from '@/src/core/theme';

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => (
  <MUIThemeProvider theme={BiologistexTheme}>{children}</MUIThemeProvider>
);

export default ThemeProvider;
